import React, {useState,useEffect} from 'react';
import {Autocomplete} from "@mui/material";
import {useOktaAuth} from '@okta/okta-react';
import {useClient} from "../../as2-onboarding-component/hooks/useClient";
import TextField from '@mui/material/TextField';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

const StyledPopper = styled(Popper)({
    '& .MuiAutocomplete-paper': {
        maxHeight: 200,
        overflowY: 'auto !important',

    },
});



export default function SearchSupplier(props){
    const [, setSupplierName] = useState(null);

    const [valueToSearch, setValueToSearch] = useState("");
    const {oktaAuth} = useOktaAuth();
    const client = useClient(oktaAuth.getAccessToken());

    useEffect(() => {
        const fetchSupplierData = async () => {
            await client.get(process.env.REACT_APP_API_BASE_URL + "/getSupplierInfoEmployee?queryString=" + valueToSearch).then((response) => {
                const data = response.data.map((supp) => {
                    const {supplierNumber, supplierName} = supp;
                    return {
                        "supplierNumber": supplierNumber,
                        "supplierName": supplierNumber + " - " + supplierName
                    };
                });
                props.setSupplierList(data);
            }).catch((error) => {
                console.log(error);
            });

        }


        if (valueToSearch.length >= 3) {
            fetchSupplierData();

        }
    }, [valueToSearch]);

    const supplierChangeHandler = (event, newValue, reason) => {
        if ( (reason === "selectOption")) {
            props.setSupplierNumber(newValue.value);
            setSupplierName(newValue.label.slice(13));

        } else if (reason === "clear") {
            props.setSupplierNumber("");
            setSupplierName("");
            setValueToSearch("");
            props.setInputSupplier("");
            props.setSupplierList([]);
        }

    }

    return (
        <>

            <Autocomplete
                sx={{ width: 100 }}
                slots={{ popper: StyledPopper }}
                slotProps={{
                    popper: {
                        modifiers: [
                            {
                                name: 'preventOverflow',
                                options: {
                                    altAxis: true,
                                },
                            },
                        ],
                    },
                }}
                onChange={supplierChangeHandler}
                inputValue={props.inputSupplier}
                onInputChange={(event, newValue, reason) => {
                    if ((event === null && reason === "reset") || (event.type === "blur" && reason === "reset")) {
                        props.setInputSupplier("");
                    } else {
                        props.setInputSupplier(newValue);
                        if (reason === "input") {
                            setValueToSearch(newValue);
                        }
                    }
                }}
                isOptionEqualToValue={(option, value) => option.label === value.label}
                options={props.supplierList.map((e) => ({
                    value: e.supplierNumber,
                    label: e.supplierName
                }))}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        fullWidth
                        placeholder={'Start Typing...'}
                    />
                )}
            />


            </>

    )
}